module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATBAMAAACJlYuFAAAAAXNSR0IB2cksfwAAABhQTFRFAAAAADBQADVUADVVADVUADVUADRUADVVQijt2gAAAAh0Uk5TABDPYP+gQNDYYtMDAAAAZ0lEQVR4nE2OsRGAMAwDnYKeo8kAMAA7xKF2wQAZAvbHMo4TVdK9TjbRr7TT0MZn+HRwmQAHUsCBFoaak0d9tb6WswaxfjFUfciQ+BDQ2y8ArQg3wuUnsGP9fqLGW3kAoAEUyRRSuA8AhBRkDas0CgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--tips.png
// module id = 945
// module chunks = 0